import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fbc8da20&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fbc8da20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc8da20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbc8da20')) {
      api.createRecord('fbc8da20', component.options)
    } else {
      api.reload('fbc8da20', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fbc8da20&scoped=true&", function () {
      api.rerender('fbc8da20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GvZ9dS5za3fH/JS/comp/DocBox.vue"
export default component.exports